import {
  MdKeyboardDoubleArrowLeft,
  MdKeyboardDoubleArrowRight,
} from "react-icons/md";
import { useShallow } from "zustand/react/shallow";
import { useAppStore } from "../store/useAppStore";

const ContentTitle = ({ title }) => {
  const setSidebarVisible = useAppStore((state) => state.setSidebarVisible);
  const sidebarVisible = useAppStore(
    useShallow((state) => state.sidebarVisible),
  );

  return (
    <div className="navbar bg-base-100 sticky top-0 shadow-md">
      <div className="flex flex-1 flex-row items-center">
        <button
          className="btn btn-ghost btn-circle hidden lg:flex"
          onClick={() => setSidebarVisible(!sidebarVisible)}
          aria-label={sidebarVisible ? "Hide sidebar" : "Show sidebar"}
        >
          {sidebarVisible ? (
            <MdKeyboardDoubleArrowLeft className="h-5 w-5" />
          ) : (
            <MdKeyboardDoubleArrowRight className="h-5 w-5" />
          )}
        </button>
        <h1 className="ml-2 text-2xl font-semibold">{title}</h1>
      </div>
    </div>
  );
};

export default ContentTitle;
